import { Observable } from 'rxjs';
import { UseCase } from '../../../base/use-case';
import { ConfigurationRepository } from '../../../repositories/configuration.repository';
import { ThirdCompanyResponseModel } from '../../../models/configuration/company/third-company.model';
import { ThirdCompanyResponseEntity } from '../../../../data/repositories/configuration/entities/company/third-company.entity';

export class GetThirdCompanyUseCase implements UseCase<{IdTipoDocumento:string, NumeroDocumento:string}, ThirdCompanyResponseModel>{
    constructor(private configRepository: ConfigurationRepository) { }
    execute(
      params: {IdTipoDocumento:string, NumeroDocumento:string}
    ): Observable<ThirdCompanyResponseEntity> {
      return this.configRepository.getThirdCompany(params);
    }
}